import { QUES_COMPONENT_TYPES } from '../componentTypes';

export default [
  {
    sequenceNumber: 1,
    // subTitle: 'What is your transaction’s deal type?', // show in complexity
    content: 'What is your transaction’s deal type?',
    subSection: 'Integration Approach & Considerations', // show in complexity
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      { text: 'Standalone' },
      { text: 'Tuck-In' },
      { text: 'Absorption / Consolidation' },
      { text: 'Transformational' },
    ],
    compLocation: 'up',
    label: true,
  },
  {
    sequenceNumber: 2,
    // subTitle:
    //   'Is the entity being purchased a Joint Venture (JV), Carve Out entity, or Wholly Acquired Entity?',
    content:
      'Is the entity being purchased a Joint Venture (JV), Carve Out entity, or Wholly Acquired Entity?',
    subSection: 'Integration Approach & Considerations',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      { text: 'Wholly acquired entity' },
      { text: 'Carve-out entity' },
      { text: 'Joint Venture (JV)' },
    ],
    compLocation: 'up',
  },
  {
    sequenceNumber: 3,
    // subTitle: 'How much time is there to until projected deal close?',
    content: 'How much time is there to until the projected deal close?',
    subSection: 'Integration Approach & Considerations',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [{ text: '< 6 months' }, { text: '> 6 months' }],
  },
  {
    sequenceNumber: 4,
    subTitle: 'Likelihood of Delayed Deal',
    content:
      'What is the likelihood that the deal could be delayed due to regulatory challenges or extended review?',
    subSection: 'Integration Complicating Factors',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 5,
      extremeTexts: [
        'Very Unlikely',
        'Unlikely',
        'Somewhat Likely',
        'Likely',
        'Very Likely',
      ],
    },
    // compLocation: 'up',
    isStrategyCollapse: true,
  },
  {
    sequenceNumber: 5,
    content: 'How important are revenue synergies to the deal?',
    subSection: 'Synergies',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 3,
      extremeTexts: ['Not Important', 'Somewhat Important', ' Very Important'],
    },
    compLocation: 'down',
  },
  {
    sequenceNumber: 6,
    content: 'How important are cost synergies to the deal?',
    subSection: 'Cost Synergies',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 3,
      extremeTexts: ['Not Important', 'Somewhat Important', ' Very Important'],
    },
    compLocation: 'down',
    cancelPointEvent: true,
  },
  {
    sequenceNumber: 7,
    subTitle: `TODO subTitle`,
    content:
      'What level of operational diligence has been performed (e.g, IT, Go to Market, Operations, People & Culture etc.) ? ',
    subSection: 'TODO subSection',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      { text: 'None' },
      { text: 'Minimal' },
      { text: 'Medium' },
      { text: 'Comprehensive' },
      { text: 'Completely Comprehensive' },
    ],
    compLocation: 'up',
    // attribute: 'Decisions / Guiding Principles', // for the input box title
  },
];
